module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/join/step-screen-1-bf29f0611e2e7cba4621a1db4117f939.png";